import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d9e7b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Recibo")
], -1))
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "No: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de Pago: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de Recepción: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Médico: ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cliente: ", -1))
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Valores")
], -1))
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bruto: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Retención: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Neto: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", null, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.no), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.fechaPago), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.fechaRecepcion), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.tipo), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.medico), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.cliente), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h6", null, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.bruto), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.retension), 1)
            ]),
            _createElementVNode("h6", null, [
              _hoisted_17,
              _createTextVNode(_toDisplayString(_ctx.currentRecibo.neto), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}